import { Injectable, Injector } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from '@node_modules/rxjs/operators';
import { BackgroundJobExecution } from '@shared/models/jobs/background-job-execution';
import { Observable } from 'rxjs';

@Injectable()
export class JobsService extends BaseService {
    constructor(private readonly _httpClient: HttpClient, protected readonly injector: Injector) {
        super(injector);
    }

    /**
     * Gets a collection of enqueued jobs
     * @param jobType Job Type
     */
    getEnqueuedJobs(jobType: string): Observable<BackgroundJobExecution[]> {
        let url = this.environment.backendUrl + '/api/services/app/job/GetEnqueuedJobs';
        url = url.replace(/[?&]$/, '');

        let params = new HttpParams();
        params = params.append('jobType', jobType);

        return this._httpClient.get<any>(url, { params: params }).pipe(
            map((response: any) => {
                const result = response.result as BackgroundJobExecution[];

                result.forEach((item: BackgroundJobExecution) => {
                    item.metaDataAsObject = item.metadata ? JSON.parse(item.metadata) : undefined;
                    item.jobResultAsObject = item.jobResult ? JSON.parse(item.jobResult) : undefined;
                });

                return result;
            }),
            catchError(this.handleError)
        );
    }

    /**
     * Triggers an enqueued reprocess job
     * @param id Job UUID
     */
    triggerEnqueuedReprocessJob(id: string): Observable<void> {
        let url = this.environment.backendUrl + '/api/services/app/job/triggerEnqueuedReprocessJob';
        url = url.replace(/[?&]$/, '');

        let params = new HttpParams();
        params = params.append('uuid', id);

        return this._httpClient.post<void>(url, undefined, { params: params }).pipe(catchError(this.handleError));
    }

    retry(id: string): Observable<BackgroundJobExecution> {
        let url = this.environment.backendUrl + '/api/services/app/Job/retry/' + id;

        return this._httpClient.post<BackgroundJobExecution>(url, undefined, {}).pipe(catchError(this.handleError));
    }
}
